import { TFunction } from "i18next";
import i18n from "../i18n";

export interface IProvider {
  link: string;
  url: string;
  headers?: Record<string, string>;
}

export interface IProviderWithTitle extends IProvider {
  title: string;
}

export const getScoutProviders = (t: TFunction): IProviderWithTitle[] => {
  const language = i18n.language as "sv" | "en";
  return [
    {
      url: `${
        import.meta.env.VITE_PLAYMAKER_BASE
      }/api/scout-reports/rss?lang=${language}&league=allsvenskan`,
      link: `${import.meta.env.VITE_PLAYMAKER_BASE}/scout`,
      title: t("feed.providers.title1", "Latest News from Playmaker AI"),
    },
  ];
};
